import React from "react";
import Skeleton from "./Skeleton";

/**
 * Skeleton loader for table rows
 * @param {Object} props - Component props
 * @param {number} props.rows - Number of skeleton rows to display (default: 5)
 * @param {number} props.columns - Number of skeleton columns to display (default: 6)
 */
const SkeletonTable = ({ rows = 5, columns = 6 }) => {
  return (
    <div className="p-3 w-100">
      {/* Skeleton Header Row */}
      <div className="d-flex gap-3 mb-3 pb-3" style={{ borderBottom: '1px solid #dee2e6' }}>
        {Array.from({ length: columns }).map((_, colIndex) => (
          <div
            key={`skeleton-header-${colIndex}`}
            style={{ flex: colIndex === 0 ? '0 0 80px' : 1 }}
          >
            <Skeleton
              variant="text"
              height="24px"
              style={{ opacity: 0.8 }}
            />
          </div>
        ))}
      </div>
      
      {/* Skeleton Data Rows */}
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <div
          key={`skeleton-row-${rowIndex}`}
          className="d-flex gap-3 mb-3 align-items-center py-2"
          style={{ borderBottom: '1px solid #f0f0f0' }}
        >
          {Array.from({ length: columns }).map((_, colIndex) => (
            <div
              key={`skeleton-col-${rowIndex}-${colIndex}`}
              style={{ flex: colIndex === 0 ? '0 0 80px' : 1 }}
            >
              <Skeleton
                variant="text"
                height={colIndex === 0 ? "24px" : "18px"}
                width={colIndex === 0 ? "60%" : "80%"}
              />
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default SkeletonTable;

